import { render } from "./Entity.vue?vue&type=template&id=559d190c&ts=true"
import script from "./Entity.vue?vue&type=script&lang=ts"
export * from "./Entity.vue?vue&type=script&lang=ts"

import "./Entity.vue?vue&type=style&index=0&id=559d190c&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__